import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentUser } from '../../services/currentUser.service';
import { UserAccount } from '../../services/userAccount.service';
import { StoriesService } from '../../+stories/list/list.service';
import { FirebaseService } from 'app/services/firebase.service';
import { Store } from '@ngrx/store';
import * as fromApp from '../../app.reducer';
import { FacebookService } from 'app/services/facebook.service';
import { FileUploader } from 'ng2-file-upload';
import { AddPhotosToGridService } from 'app/services/add-photos-to-grid.service';
import { AuthService } from 'angularx-social-login';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './appHeader.component.html',
  styleUrls: ['./appHeader.component.scss'],
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  @ViewChild('searchInput', { static: false }) private searchInput;
  @ViewChild('fileInput', { static: false }) private fileInput;
  currentPage;
  isMobile;
  uploader: any = new FileUploader({});
  addPhotosHeader = true;

  subscriptions = new Subscription();

  constructor(
    private router: Router,
    private currentUser: CurrentUser,
    public stories: StoriesService,
    public userAccount: UserAccount,
    private firebaseService: FirebaseService,
    private facebookService: FacebookService,
    private store: Store<fromApp.AppState>,
    private addPhotosToGridService: AddPhotosToGridService,
    private authService: AuthService,
  ) {}

  public searchExpanded = false;

  ngOnInit() {
    this.store.select('shared').subscribe(store => {
      this.currentPage = store.currentPage;
      this.isMobile = store.isMobile;
    });

    this.addPhotosToGridService._addPhotosHeader.subscribe(response => {
      this.addPhotosHeader = response;
    });
  }

  public logout(guest?: boolean) {

    this.subscriptions.add(
      this.authService.authState.subscribe(authState => {
        if (authState) {
          this.authService.signOut().then(
            () => {
              this.router.navigate(['/account/login']);
            }
          );
        }
      }
      )
    );
    if ((this.currentUser.get() ? this.currentUser.get().guest : true) || !guest) {
      this.router.navigate(['/account/login']);
    }
    this.firebaseService.logEvent('logout');
    this.firebaseService.setUserId('');
    this.currentUser.clear();
    this.userAccount.clear();
    this.facebookService.clearUserId();
  }

  public expandSearch() {
    this.searchExpanded = true;
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 100);
  }

  public collapseSearch() {
    this.searchExpanded = null;
    this.stories.search('');
  }

  public search(event) {
    this.stories.search(event.target.value);
  }

  public isSearchAvailable() {
    return this.router.url === '/stories';
  }

  public isUsernameAvailable() {
    return  this.router.url === '/stories/new' ||
            this.router.url === '/stories' ||
            this.router.url === '/stories/orders' ||
            this.router.url === '/profile/country' ||
            this.router.url === '/profile/settings';
  }

  isRouteActive(url, exact) {
    return this.router.isActive(url, exact);
  }

  showAssistantModal() {
    this.addPhotosToGridService.addPhotos(true);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
